export default __webpack_public_path__ + "static/media/imovel.89841839.jpg";